"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValueDisplay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    field: {
        margin: theme.spacing(0.5, 0),
    },
    key: {
        width: '180px',
    },
    value: {
        flex: 1,
        marginLeft: theme.spacing(0.5),
    },
}));
const KeyValueDisplay = ({ label, value }) => {
    const classes = useStyles();
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, className: classes.field, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { className: classes.key, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { color: "textSecondary", children: label }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: " : " }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { className: classes.value, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { color: "textSecondary", children: value }) })] }));
};
exports.KeyValueDisplay = KeyValueDisplay;
//# sourceMappingURL=KeyValueDisplay.js.map